import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogGanadorAutoInput,
    LogGanadorAuto,
    ModelLogGanadorAutoFilterInput,
    UpdateLogGanadorAutoInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class LogGanadorAutoService {
    private amplifyClient = generateClient();

    async listAllLogGanadorAutos(
        limit: number = 500,
        filter: ModelLogGanadorAutoFilterInput = null
    ): Promise<LogGanadorAuto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogGanadorAutos,
                    variables: { limit, filter }
                })
            ).data.listLogGanadorAutos.items;
            if (data) return data as LogGanadorAuto[];
        } catch (error) {
            console.error('Error finding listLogGanadorAutos:', error);
            return null;
        }
    }

    async listLogGanadorAutosPaginated(
        limit: number = 9999,
        filter: ModelLogGanadorAutoFilterInput = null
    ): Promise<{ items: LogGanadorAuto[]; nextToken?: string | null }> {
        try {
            return (
                await this.amplifyClient.graphql({
                    query: queries.listLogGanadorAutos,
                    variables: { limit, filter }
                })
            ).data.listLogGanadorAutos;
        } catch (error) {
            console.error('Error finding listLogGanadorAutos:', error);
            return { items: [] };
        }
    }

    async listLogGanadorAutos(): Promise<LogGanadorAuto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogGanadorAutos
                })
            ).data.listLogGanadorAutos.items;
            if (data) return data as LogGanadorAuto[];
        } catch (error) {
            console.error('Error finding listLogGanadorAutos:', error);
            return null;
        }
    }

    async listLogsByAuto(id_auto: string): Promise<LogGanadorAuto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListLogsByAuto,
                    variables: {
                        id_auto
                    }
                })
            ).data.ListLogsByAuto.items;
            if (data) return data as LogGanadorAuto[];
        } catch (error) {
            console.error('Error finding ListLogsByAuto:', error);
            return null;
        }
    }

    async logsGanadorAutoByUser(id_user: string): Promise<LogGanadorAuto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.LogsGanadorAutoByUser,
                    variables: {
                        id_user
                    }
                })
            ).data.LogsGanadorAutoByUser.items;
            if (data) return data as LogGanadorAuto[];
        } catch (error) {
            console.error('Error finding ListLogsByAuto:', error);
            return null;
        }
    }

    async createLogGanadorAuto(
        input: CreateLogGanadorAutoInput
    ): Promise<LogGanadorAuto> {
        try {
            const logGanador = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogGanadorAuto,
                    variables: {
                        input
                    }
                })
            ).data.createLogGanadorAuto;
            if (logGanador) return logGanador as LogGanadorAuto;
        } catch (error) {
            console.error('Error creating createLogGanadorAuto:', error);
            return null;
        }
    }

    async updateLogGanadorAuto(
        input: UpdateLogGanadorAutoInput
    ): Promise<LogGanadorAuto> {
        try {
            const logGanador = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogGanadorAuto,
                    variables: {
                        input
                    }
                })
            ).data.updateLogGanadorAuto;
            if (logGanador) return logGanador as LogGanadorAuto;
        } catch (error) {
            console.error('Error creating updateLogGanadorAuto:', error);
            return null;
        }
    }
}
